"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectValues = function (o) { return Object.keys(o).map(function (key) { return o[key]; }); };
//# sourceMappingURL=utils.js.map